module.exports = __webpack_public_path__ + "img/create-success.32967792.png";